<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{
        titleProp ? $t(titleProp) : $t($route.name)
      }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet && !mobileShow" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile && type !== 'removedChecks' && !mobileShow"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && !mobileShow"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col v-if="mobileShow" class="py-0 pt-3 px-2" cols="12">
        <v-chip-group v-model="type" mandatory active-class="primary--text">
          <v-chip small dark label value="payCheck">
            {{ $t("payCheckList") }}
          </v-chip>
          <v-chip small label value="recieveCheck">
            {{ $t("recieveCheckList") }}
          </v-chip>
        </v-chip-group>
      </v-col>
      <v-col v-show="!isMobile" class="px-1 py-2" cols="12" md="12">
        <div class="d-flex align-center justify-space-between gap-2">
          <!-- <v-chip-group
            mandatory
            active-class="primary--text"
            class="justify-start"
            style="padding-top: 1px"
          >
            <v-chip label outlined>
              {{ $t("totalSum") }} : {{ $numberFormat(summary ? summary.amount : 0) }}
              {{ $store.state.currency.name }}
            </v-chip>
          </v-chip-group> -->
        </div>
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2">
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :page.sync="page"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'own' ? true : false,
                  'mobile-td-list-border-green': item.type == 'customer' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          v-show="item.kind !== 'guarantee'"
                          link
                          @click="openCheckStatusDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-qrcode-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            $baseURL +
                            '/' +
                            (item.type == 'own' ? 'check/pay' : 'check/recieve') +
                            '/edit/' +
                            item.id
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="pb-0">
                  <v-list-item-title class="text-wrap">
                    {{ item.account ? item.account.name : "" }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("bank") }} : {{ item.bank ? item.bank.name : "" }} |
                    {{ $t("number") }} {{ $t("check") }}: {{ item.number }} |
                    {{ $t("id") }} : {{ item.id }} | {{ $t("date") }} : {{ item.date }} |
                    {{ $t("due") }} : {{ item.due_date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-if="item.status && item.status.status"
                      :color="item.status.color"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1"
                      @click="openCheckStatusDialog(item)"
                    >
                      <span class="px-2 white--text">
                        {{ $t(item.status.status) }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.payed_account_id && item.type == 'customer'"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      class="px-1 ma-1"
                    >
                      <span class="px-2 white--text">
                        {{ $t("to") }}
                        {{
                          item.payed_account ? $t(item.payed_account.name) : $t("haveNot")
                        }}
                        - {{ $t("date") }}:{{ item.payed_date }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="type == 'payCheck' && item.type == 'customer'"
                      color="teal"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("recieveCheck") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.initial_period"
                      color="primary"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("initialPeriod") }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="green"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ item.status.bank.name }}
                      </span>
                    </v-chip>
                    <v-chip
                      v-if="item.status && item.status.bank"
                      color="orange"
                      label
                      small
                      style="cursor: pointer"
                      outlined
                      class="px-1 ma-1"
                    >
                      <span class="px-2">
                        {{ $t("lastChangeStatus") }} : {{ item.status.time }}
                      </span>
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-for="(relation, index) in item.relations"
                      :key="index"
                      :color="relation.color"
                      label
                      outlined
                      small
                      style="margin-left: 1px; margin-right: 1px"
                      class="px-1 mb-1"
                      @click="edit(item)"
                    >
                      {{ relation.name }}
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.tags" class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.amount) }}
                    {{ item.currency ? item.currency.name : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                v-show="type !== 'removedChecks' && item.kind !== 'guarantee'"
                link
                @click="openCheckStatusDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-qrcode-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('change') + ' ' + $t('status')" />
              </v-list-item>
              <v-list-item
                v-if="type !== 'removedChecks'"
                v-clipboard:copy="
                  $baseURL +
                  '/' +
                  (item.type == 'own' ? 'check/pay' : 'check/recieve') +
                  '/edit/' +
                  item.id
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip v-if="item.user" top>
            <template v-slot:activator="{ on, attrs }">
              <div color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.id="{ item }">
          <a
            @click="
              (item.status && item.status.status == 'issued') ||
              (item.status && item.status.status == 'fund')
                ? edit(item)
                : null
            "
          >
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
          <v-chip
            v-if="type === 'removedChecks'"
            :color="item.type === 'own' ? 'blue' : 'green'"
            label
            small
            style="margin-left: 1px; margin-right: 1px"
            class="px-1 mb-1"
          >
            <span class="px-1 white--text"> {{ $t("check") }} {{ $t(item.type) }} </span>
          </v-chip>
        </template>
        <!-- <template v-slot:item.doc_header.number="{ item }">
          <a v-if="item.doc_header" @click="documentPrint(item)">
            {{
              item.payedDocumentNumber ? item.payedDocumentNumber : item.doc_header.number
            }}
          </a>
        </template> -->
        <template v-slot:item.number="{ item }">
          <span v-if="item.number">{{ item.number }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.account.name="{ item }">
          <div v-if="item.account" class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.account.id)"
            >
              {{ item.account.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.account.fin_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("turnover") }}</span>
            </v-tooltip>
          </div>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.date="{ item }">
          <span v-if="item.date">{{ item.date }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.due_date="{ item }">
          <span v-if="item.due_date">{{ item.due_date }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.fisherman_number="{ item }">
          <span v-if="item.fisherman_number">{{ item.fisherman_number }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.branch.name="{ item }">
          <span v-if="item.branch && item.branch.name">{{ item.branch.name }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.content="{ item }">
          <span v-if="item.content">{{ item.content }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.row="{ item }">
          <a
            @click="
              (item.status && item.status.status == 'issued') ||
              (item.status && item.status.status == 'fund')
                ? edit(item)
                : null
            "
          >
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <div v-if="item.tags && item.tags.length" class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.amount="{ item }">
          <span v-if="item.amount">
            {{
              $numberFormat(
                item.amount,
                item.currency && item.currency.decimal != null
                  ? item.currency.decimal
                  : $store.state.currency.decimal
              )
            }}
            {{
              item.currency && $store.state.currency.id !== item.currency.id
                ? "(" + item.currency.symbol + ")"
                : ""
            }}
          </span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.currency="{ item }">
          <span v-if="item.currency">{{ item.currency.name }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.bank="{ item }">
          <span v-if="item.type === 'own' && item.bank && item.bank.name">
            {{ item.bank.name }}
          </span>
          <span v-else-if="item.type === 'customer' && item.bank_name">
            {{ item.bank_name }}
          </span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.kind="{ item }">
          <!-- {{ item.type == "own" ? $t("normal") : $t(item.kind) }} -->
          <span v-if="item.kind">{{ $t(item.kind) }}</span>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.relations="{ item }">
          <div v-if="item.relations && item.relations.length" class="pt-1">
            <v-chip
              v-for="(relation, index) in item.relations"
              :key="index"
              :color="relation.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ relation.name }}
            </v-chip>
          </div>
          <div v-else class="text-center">-</div>
        </template>
        <template v-slot:item.status.status="{ item }">
          <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
            @click="openCheckStatusDialog(item)"
          >
            <span class="px-2 white--text">
              {{ $t(item.status.status) }}
              {{
                item.status.status === "fund" && item.cashbox
                  ? "&nbsp;" + item.cashbox.name + ""
                  : ""
              }}
            </span>
          </v-chip>
          <v-chip v-else color="#DCE8DE" label small class="px-1">
            <span class="px-2"> {{ $t("not_issued") }}</span>
          </v-chip>
          <!-- <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
            @click="openCheckStatusDialog(item)"
          >
            <span class="px-2 white--text">
              {{ $t(item.status.status) }}
              {{
                item.status.status === "fund" && item.cashbox
                  ? "&nbsp;" + item.cashbox.name + ""
                  : ""
              }}
            </span>
          </v-chip> -->
          <v-chip
            v-if="item.payed_account_id && item.type == 'customer'"
            color="primary"
            label
            small
            style="cursor: pointer"
            class="px-1 ma-1"
          >
            <span class="px-2 white--text">
              {{ $t("to") }} {{ $t(item.payed_account.name) }} - {{ $t("date") }}:{{
                item.payed_date
              }}
            </span>
          </v-chip>
          <v-chip
            v-if="type == 'payCheck' && item.type == 'customer'"
            color="teal"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("recieveCheck") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.initial_period"
            color="primary"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("initialPeriod") }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="green"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ item.status.bank.name }}
            </span>
          </v-chip>
          <v-chip
            v-if="item.status && item.status.bank"
            color="orange"
            label
            small
            style="cursor: pointer"
            outlined
            class="px-1 ma-1"
          >
            <span class="px-2">
              {{ $t("lastChangeStatus") }} : {{ item.status.time }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <!-- <template v-slot:body.append>
          <tr>
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong
                >:
                <v-chip color="primary" class="px-1">
                  <span class="px-1 white--text">
                    {{ $numberFormat(totals.sum) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template> -->
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="checkStatusDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="checkStatusDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("status") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <checkStatus v-model="lastStatus" :check-item="checkItem" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <div style="position: fixed; z-index: 2">
            <v-btn icon color="grey darken-2" @click="printDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
          </div>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :turnover-prop="totals"
            :from-date="fromDate"
            :to-date="toDate"
            :title="$t('list') + ' ' + $t(type)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              :title="type == 'payCheck' ? $t('reciever') : $t('payer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col v-if="type == 'payCheck'" cols="12" md="4">
            <autocomplete
              v-model="bank"
              :title="$t('bank')"
              type="bank"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="4">
            <autocomplete
              v-model="bankRecieve"
              :title="$t('bank')"
              type="bankCheckRecieve"
              :filter="false"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :label="$t('status')"
              :items="statusItems"
              height="30"
              dense
              outlined
              multiple
              clearable
              item-value="value"
              item-text="text"
              item-disabled="disable"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col v-if="type == 'recieveCheck'" cols="12" md="4">
            <autocomplete
              v-model="cashBox"
              :title="$t('cashBox')"
              type="getCash"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="documentPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <documentPrint :id-prop="documentId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="recieveCheck"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import Task from "../task/task";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import checkStatus from "./checkStatus";
import documentPrint from "../accounting/print";
import dialogComponent from "../../components/general/dialog/index";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import moment from "moment-jalaali";
import { numberFormat } from "highcharts";

export default {
  name: "CheckSheetsList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    documentPrint,
    checkStatus,
    dialogComponent,
    Task,
    MyIcon,
    Upload,
  },
  mixins: [General],
  props: ["input", "refId", "typeProp", "mobileShow", "statusProp", "titleProp"],
  data: () => ({
    excelItems: [],
    printHeaders: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    cashBox: null,
    registerar: null,
    removedChecks: null,
    summary: null,
    bankRecieve: null,
    account: null,
    bank: null,
    currencyFilter: null,
    deletDialog: false,
    uploadDialog: false,
    documentPrintDialog: false,
    checkStatusDialog: false,
    showSelect: true,
    filter: false,
    dialogData: null,
    statusItems: [],
    documentId: null,
    checkItem: null,
    fromDate: null,
    toDate: null,
    lastStatus: null,
    lastStatusItemIndex: null,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    status: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarColor: null,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    selectedHeaders: [],
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    fromCheckDate: null,
    toCheckDate: null,
    fromAmount: null,
    toAmount: null,
    check_series: null,
    checkNumber: null,
    fisherman_number: null,
  }),
  computed: {
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    totals: function () {
      if (!Array.isArray(this.items)) {
        return { sum: 0 };
      }
      const totals = this.items.reduce(
        (acc, d) => {
          acc.sum += parseFloat(d.amount);
          return acc;
        },
        {
          sum: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    type() {
      if (this.mobileShow) {
        if (this.type === "payCheck") {
          this.status = ["issued"];
        } else {
          this.status = ["fund"];
        }
      }
      this.getItems();
    },
    lastStatus() {
      this.items[this.lastStatusItemIndex].status = this.lastStatus;
      this.checkStatusDialog = false;
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    this.getItems();
  },
  beforeMount() {
    this.statusItems = [
      {
        value: "fund",
        text: this.$t("fund"),
      },
      {
        value: "issued",
        text: this.$t("issued"),
      },
      {
        value: "notissued",
        text: this.$t("notissued"),
      },
      {
        value: "returned",
        text: this.$t("returned"),
      },
      {
        value: "passed",
        text: this.$t("passed"),
      },
      {
        value: "bank",
        text: this.$t("inBank"),
      },
      {
        value: "payed",
        text: this.$t("payed"),
      },
      {
        value: "canceled",
        text: this.$t("canceled"),
      },
    ];
    if (this.$route.name === "checkSheetsList") {
      this.type = "payCheck";
      if (!this.statusProp) {
        this.status = ["issued"];
      }
    }
    if (this.$route.name === "recieveCheckList") {
      this.type = "recieveCheck";
    }
    if (this.$route.name === "removedChecks") {
      this.type = "removedChecks";
      this.removedChecks = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }
    if (this.statusProp) {
      this.status = [this.statusProp];
    }
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: true,
        value: "id",
        table: "checks.id",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        sortable: false,
        value: "number",
      },
      {
        text: this.$t("bank"),
        sortable: false,
        value: "bank",
      },
      // {
      //   text: this.$t("number") + " " + this.$t("document"),
      //   sortable: false,
      //   value: "doc_header.number",
      // },
      {
        text: this.$t("name") + " " + this.$t("account"),
        sortable: false,
        value: "account.name",
      },
      // {
      //   text: this.$t("kind"),
      //   sortable: false,
      //   value: "kind",
      // },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "checks.date",
      },
      {
        text: this.$t("dueDate"),
        sortable: true,
        value: "due_date",
        table: "checks.due_date",
      },
      {
        text: this.$t("fishermanNumber"),
        sortable: true,
        value: "fisherman_number",
        table: "checks.fisherman_number",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      {
        text: this.$t("amount"),
        sortable: false,
        width: 100,
        value: "amount",
      },
      {
        text: this.$t("currency"),
        sortable: false,
        value: "currency",
      },
      {
        text: this.$t("status"),
        sortable: true,
        value: "status.status",
        table: "checks_status.status",
      },
      {
        text: this.$t("relations"),
        sortable: false,
        value: "relations",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        table: "bank_cash.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      // {
      //   text: this.$t("number") + " " + this.$t("document"),
      //   value: "doc_header",
      // },
      {
        text: this.$t("name") + " " + this.$t("account"),
        value: "account",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        value: "number",
      },
      {
        text: this.$t("bank"),
        value: "bank",
      },
      // {
      //   text: this.$t("kind"),
      //   value: "kind",
      //   type: "translate",
      // },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("dueDate"),
        value: "due_date",
        width: 15,
      },
      {
        text: this.$t("status"),
        value: "status_label",
      },
      {
        text: this.$t("amount"),
        width: 10,
        type: "number",
        value: "amount",
        sum: true,
      },
    ];
    if (this.$route.params.id != null) {
      this.show();
      this.id = this.$route.params.id;
      this.render = false;
    }
    this.selectedHeaders = this.headers;
  },
  mounted() {
    if (this.input) {
      this.model = this.input;
    }
    this.getItems();
  },
  methods: {
    openUploadDialog() {
      this.uploadDialog = true;
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    documentPrint(item) {
      this.documentId = item.doc_head_id;
      this.documentPrintDialog = true;
    },
    openCheckStatusDialog(item) {
      this.checkItem = item;
      this.checkStatusDialog = true;
      this.lastStatusItemIndex = this.items.indexOf(item);
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedChecks) {
        this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
      }
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "own-checks/filter", {
          params: app.buildOwnChecksFilterParams(),
        })
        .then((res) => {
          const payload = app.normalizeOwnChecksResponse(res.data);
          if (!app.allRows) {
            app.items = payload.items;
            app.totalItems = payload.total;
            app.pageCount = payload.last_page;
            app.from = payload.from;
            app.summary = payload.summary;
            app.creatExcelData(payload.items);
          } else {
            app.generateExcellForAllData(payload.items, payload.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    buildOwnChecksFilterParams() {
      const app = this;
      const params = {
        options: JSON.stringify({
          page: app.allRows ? app.excelPage : app.options.page,
          itemsPerPage: app.options.itemsPerPage,
        }),
      };

      if (app.status && app.status.length) {
        params.status = app.status;
      }

      const accountId = app.resolveFilterId(app.account);
      if (accountId != null) {
        params.account_id = accountId;
      }

      const bankId = app.resolveFilterId(app.bank);
      if (bankId != null) {
        params.bank_id = bankId;
      }
      if (app.currencyFilter) {
        params.currencyFilter = app.currencyFilter;
      }
      if (app.branch) {
        params.branch = app.branch;
      }
      if (app.lockStatus) {
        params.lockStatus = app.lockStatus;
      }
      if (app.tag) {
        params.tag = app.tag;
      }
      if (app.registerar) {
        params.registerar = app.registerar;
      }
      if (app.fromDate) {
        params.from_due_date = app.fromDate;
      }
      if (app.toDate) {
        params.to_due_date = app.toDate;
      }
      if (app.fromCheckDate) {
        params.from_date = app.fromCheckDate;
      }
      if (app.toCheckDate) {
        params.to_date = app.toCheckDate;
      }
      if (app.fromAmount != null && app.fromAmount !== "") {
        params.fromAmount = app.fromAmount;
      }
      if (app.toAmount != null && app.toAmount !== "") {
        params.toAmount = app.toAmount;
      }
      if (app.check_series) {
        params.check_series = app.check_series;
      }
      if (app.checkNumber) {
        params.number = app.checkNumber;
      }
      if (app.fisherman_number) {
        params.fisherman_number = app.fisherman_number;
      }
      if (app.search) {
        params.search = app.search;
      }

      return params;
    },
    mapOwnCheckItem(item) {
      if (!item) {
        return item;
      }

      const mapped = { ...item };

      if (!mapped.currency && mapped.bank && mapped.bank.currency) {
        mapped.currency = mapped.bank.currency;
      }

      if (Array.isArray(mapped.relations)) {
        mapped.relations = mapped.relations.map((relation) =>
          this.mapOwnCheckRelation(relation)
        );
      }
      mapped.status_label =
        mapped.status && mapped.status.status
          ? this.$t(mapped.status.status)
          : this.$t("not_issued");
      return mapped;
    },
    mapOwnCheckRelation(relation) {
      if (!relation) {
        return relation;
      }
      if (relation.name && relation.color) {
        return relation;
      }

      const docType = relation.doc_type || relation.type || "";
      const relationColors = {
        invoice: "blue",
        payCheck: "indigo",
        recieveCheck: "green",
      };

      return {
        ...relation,
        name:
          relation.name ||
          (relation.refrence
            ? `${this.$t(docType)} ${this.$t("number")}: ${relation.refrence}`
            : this.$t(docType)),
        color:
          relation.color ||
          relationColors[docType] ||
          relationColors[relation.type] ||
          "grey",
      };
    },
    normalizeOwnChecksResponse(payload) {
      const empty = {
        items: [],
        total: 0,
        last_page: 1,
        from: 0,
        summary: null,
      };

      if (!payload) {
        return empty;
      }

      const mapItems = (items) => (items || []).map((item) => this.mapOwnCheckItem(item));

      if (Array.isArray(payload.data)) {
        return {
          items: mapItems(payload.data),
          total: payload.total ?? payload.data.length,
          last_page: payload.last_page ?? 1,
          from: payload.from ?? 1,
          summary: payload.summary ?? null,
        };
      }

      if (payload.data && Array.isArray(payload.data.data)) {
        const inner = payload.data;
        return {
          items: mapItems(inner.data),
          total: inner.total ?? payload.total ?? inner.data.length,
          last_page: inner.last_page ?? payload.last_page ?? 1,
          from: inner.from ?? payload.from ?? 1,
          summary: inner.summary ?? payload.summary ?? null,
        };
      }

      if (Array.isArray(payload.items)) {
        return {
          items: mapItems(payload.items),
          total: payload.total ?? payload.items.length,
          last_page: payload.last_page ?? 1,
          from: payload.from ?? 1,
          summary: payload.summary ?? null,
        };
      }

      if (Array.isArray(payload)) {
        return {
          items: mapItems(payload),
          total: payload.length,
          last_page: 1,
          from: 1,
          summary: null,
        };
      }

      return empty;
    },
    resolveFilterId(value) {
      if (value == null) {
        return null;
      }
      if (Array.isArray(value)) {
        const first = value[0];
        return first != null ? first.id ?? first : null;
      }
      return value.id ?? value;
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "checks/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .delete(this.$endpoint + "checks/0", {
          params: { deleteItems: selected },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            refreshRemovedChecks: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (!Array.isArray(data)) {
        return;
      }
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          number: d.number,
          accountId: d.account_id,
          bank:
            d.type === "own"
              ? d.bank.name + "-" + d.bank.number
              : d.type === "customer"
              ? d.bank_name + "-" + d.bank_account_number
              : "",
          amount: d.amount,
          date: d.date,
          content: d.content,
          fishermanNumber: d.fisherman_number,
          dueDate: d.due_date,
          documentNumber: d.doc_header ? d.doc_header.number : "",
          account: d.account ? d.account.name : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
</style>
